export default __webpack_public_path__ + "static/media/ELearning.63ffc08a.jpg";